module.exports = __webpack_public_path__ + "img/A1954.d22dca4f.png";